"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutomationAssignment = void 0;
var react_1 = __importStar(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var classnames_1 = __importDefault(require("classnames"));
var AutomationsApiService_1 = require("./AutomationsApiService");
var styles = __importStar(require("./AssignmentModal.css"));
var AutomationPill_1 = require("Library/AutomationLibrary/Components/AutomationPill");
var useTemplatesDashboardTelemetry_1 = __importDefault(require("Dashboard/TemplateManagementDashboard/useTemplatesDashboardTelemetry"));
var UseAutomationsMetadata_1 = require("Library/AutomationLibrary/hooks/UseAutomationsMetadata");
var AutomationUtils_1 = require("Library/AutomationLibrary/AutomationUtils");
var AutomationAssignment = function (_a) {
    var query = _a.query, onCancel = _a.onCancel, onConfirm = _a.onConfirm, assignedAutomationIds = _a.assignedAutomationIds;
    var data = (0, AutomationsApiService_1.useAutomations)(query).data;
    var associationsToBeAdded = new Set(assignedAutomationIds);
    var automationsMetadata = (0, UseAutomationsMetadata_1.useAutomationsMetadata)();
    var handleAssignmentChange = function (automationId, isAssigned) {
        isAssigned ? associationsToBeAdded.add(automationId) : associationsToBeAdded.delete(automationId);
    };
    var updateCallback = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2, onConfirm(Array.from(associationsToBeAdded))];
        });
    }); };
    var renderAutomationsList = function () {
        return data && data.length !== 0 ? (data
            .sort(function (autoA, autoB) {
            return autoB.enabled.toString().localeCompare(autoA.enabled.toString()) || autoA.name.localeCompare(autoB.name);
        })
            .map(function (automation) { return (react_1.default.createElement(ExpandableAutomationItem, { isInitiallySelected: assignedAutomationIds.includes(automation.id), automation: automation, key: automation.id, onAssignmentChange: function (automationId, isAssigned) {
                handleAssignmentChange(automationId, isAssigned);
            }, integrationDisplayName: automationsMetadata.data
                ? (0, AutomationUtils_1.getAutomationIntegrationDisplayName)(automation.integration, automationsMetadata.data)
                : "" })); })) : (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", className: styles.emptyAutomationsList },
            react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "m" }, "No automations found"),
            react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "xs" }, "Create an automation to assign")));
    };
    return (react_1.default.createElement("div", { className: styles.assignmentModalBody, onMouseDown: function () { } },
        react_1.default.createElement(kaleidoscope_1.IconButton, { className: styles.closeButton, icon: react_1.default.createElement(icons_1.Close, null), onClick: onCancel }),
        react_1.default.createElement("div", { className: styles.content },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", className: styles.title }, "Assign Automation"),
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.subtitle }, "Choose which automations you want to assign to this template."),
            react_1.default.createElement("div", { className: styles.automationsList }, data ? renderAutomationsList() : react_1.default.createElement(kaleidoscope_1.Spinner, { primary: true })),
            react_1.default.createElement("div", { className: styles.footer },
                react_1.default.createElement(kaleidoscope_1.Button, { className: styles.cancelButton, size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, onClick: onCancel }, "Cancel"),
                react_1.default.createElement(kaleidoscope_1.Button, { disabled: false, className: styles.confirmButton, size: kaleidoscope_1.ButtonSize.Large, onClick: function () {
                        updateCallback();
                    }, buttonState: kaleidoscope_1.ButtonState.Idle }, "Confirm")),
            react_1.default.createElement(kaleidoscope_1.Link, { href: "/#/automations", target: "_blank" }, "Create and manage automations."))));
};
exports.AutomationAssignment = AutomationAssignment;
var ExpandableAutomationItem = function (props) {
    var telemetry = (0, useTemplatesDashboardTelemetry_1.default)();
    var _a = __read((0, react_1.useState)(false), 2), expanded = _a[0], setExpanded = _a[1];
    var _b = __read((0, react_1.useState)(props.isInitiallySelected), 2), isSelected = _b[0], setIsSelected = _b[1];
    return (react_1.default.createElement(kaleidoscope_1.Card, { className: (0, classnames_1.default)(styles.automationItem, props.automation.enabled && styles.enabled) },
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "xs" },
            react_1.default.createElement("div", { className: styles.cardHeader },
                react_1.default.createElement(kaleidoscope_1.Tooltip, { size: kaleidoscope_1.TooltipSize.Large, wrapTarget: true, content: !props.automation.enabled
                        ? "To assign this automation, go to the Automations Dashboard and turn it on"
                        : props.automation.name },
                    react_1.default.createElement(kaleidoscope_1.Checkbox, { item: { id: props.automation.id, value: props.automation.id, label: props.automation.name }, size: kaleidoscope_1.CheckboxSize.Medium, isDisabled: !props.automation.enabled, isSelected: isSelected, onChange: function () {
                            var newState = !isSelected;
                            telemetry.automationAssignmentToggled(newState);
                            setIsSelected(newState);
                            props.onAssignmentChange(props.automation.id, newState);
                        } })),
                react_1.default.createElement("div", { className: styles.rightOptions },
                    react_1.default.createElement(AutomationPill_1.AutomationPill, { integrationName: props.automation.integration, integrationDisplayName: props.integrationDisplayName }),
                    react_1.default.createElement(kaleidoscope_1.IconButton, { icon: expanded ? react_1.default.createElement(icons_1.ChevronUp, null) : react_1.default.createElement(icons_1.ChevronDown, null), onClick: function () {
                            var newState = !expanded;
                            telemetry.automationExpandToggled(props.automation.id, newState);
                            return setExpanded(newState);
                        } }))),
            react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: expanded }, function (_a) {
                var expandableElementRef = _a.expandableElementRef;
                return (react_1.default.createElement(kaleidoscope_1.Text, { id: props.automation.id, ref: expandableElementRef, className: styles.description }, props.automation.description.trim().length > 0 ? props.automation.description : "(No description)"));
            }))));
};
